import { css } from '@/styled-system/css';

export const frostedToggleButtonGroupStyles = css.raw({
  alignItems: 'center',
  gap: 'none',
});

export const frostedToggleButtonStyles = css.raw({
  borderRadius: 'pill',
  backgroundColor: 'bg.invisible',
  boxShadowColor: 'border.invisible',
  _hover: {
    backgroundColor: 'bg.action.neutral.hover',
  },
  _active: {
    backgroundColor: 'bg.action.neutral.pressed',
  },
  '&[aria-pressed="true"]': {
    backgroundColor: 'bg.action.soft.selected.default',
    boxShadow: 'sm',
    _hover: {
      backgroundColor: 'bg.action.soft.selected.hover',
    },
    _active: {
      backgroundColor: 'bg.action.soft.selected.pressed',
    },
  },
});
